<script>
  import { onMount } from "svelte";
  import ProjectExtract from "../components/extract/ProjectExtract.svelte";

  let projectId = "";
  let showViewer = false;

  onMount(() => {
    const queryParams = new URLSearchParams(window.location.search);
    projectId = queryParams.get("id") || "";
    showViewer = projectId !== "";
  });

  function handleViewerCancel() {
    showViewer = false;
  }
</script>

<div class="standalone-container">
  {#if projectId}
    <ProjectExtract show={showViewer} {projectId} on:cancel={handleViewerCancel} showExternalLink={false} />

    {#if !showViewer}
      <div>
        <p>Grid viewer closed</p>
      </div>
    {/if}
  {:else}
    <div>
      <p>No project ID provided</p>
    </div>
  {/if}
</div>
